import { ref } from 'vue';

const toasts = ref([]);
let nextId = 0;

const DEFAULT_DURATION = 5000;

// Transient popups — each fades away on its own after `duration`ms. For an
// error that should stick around until the user fixes it, use state.js's
// `computeError` instead (no timer, cleared on success).
//
// variant is 'error' (the default — nearly every call site is reporting a
// failure) or 'success', for the rare toast confirming something good
// happened (e.g. sync.js's "Sync is working again." after an outage) —
// each renderer (error_popups.vue and its per-page duplicates) styles the
// two differently.
export function useToasts() {
  function pushToast(message, { duration = DEFAULT_DURATION, variant = 'error' } = {}) {
    const id = nextId++;
    toasts.value.push({ id, message, variant });
    setTimeout(() => {
      toasts.value = toasts.value.filter(t => t.id !== id);
    }, duration);
    return id;
  }

  return { toasts, pushToast };
}
